import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [수집설정 > 로그 관리 설정] 현재 로그 관리 설정을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getCurrentLogSetting() {
    return axios.get(`${baseUrl}/settings/log/management/get-current-log-setting.do`);
  },
  /**
   * [수집설정 > 로그 관리 설정] 로그 레벨 타입 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogLevelTypeList() {
    return axios.get(`${baseUrl}/settings/log/management/get-log-level-type-list.do`);
  },
  /**
   * [수집설정 > 로그 관리 설정] 로그 저장 타입 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getSaveTypeList() {
    return axios.get(`${baseUrl}/settings/log/management/get-save-type-list.do`);
  },
  /**
   * [수집설정 > 로그 관리 설정] 로그 데이터 저장 단위 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getSaveDataUnitList() {
    return axios.get(`${baseUrl}/settings/log/management/get-save-data-unit-list.do`);
  },
  /**
   * [수집설정 > 로그 관리 설정] 로그 관리 설정을 업데이트한다.
   * @author Ju
   * @param  {[type]} params [로그 관리 설정 업데이트 데이터]
   * @return {[type]}        [description]
   */
  updateCurrentLogSetting(params) {
    return axios.post(`${baseUrl}/settings/log/management/update-current-log-setting.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/log-management-settings.js